import React, { useContext, useEffect } from "react";

import "./style.scss";

import FadeIn from "react-fade-in";

import { StateContext } from "../../AppStateContext";
import FileUploadButton from "./FileUploadButton";
import AddClassButton from "./AddClassButton";
const NewSchemaOptions = () => {
  //global state
  const state = useContext(StateContext);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <FadeIn>
      <div className="__newSchemaOptions">
        <h1
          className={state.theme === "dark" ? "__headerDark" : "__headerLight"}
          id="schemaEmptyStateHeaderText"
        >
          You don't seem to have a schema yet. Let's create one!
        </h1>
        <div className="__decisionBoxes">
          <FileUploadButton />
          <AddClassButton />
        </div>
      </div>
    </FadeIn>
  );
};

export default NewSchemaOptions;
